import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const Instruction = () => {
    document.title = "İstifadə qaydası";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Texniki dəstək", value: "/dashboard/support" },
        { name: "İstifadə qaydası", value: "/dashboard/support/instruction", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">İstifadə qaydası</h2>
                    <p>
                        Səhifələrin istifadə qaydasını izahlı şəkildə göstərmək üçün nəzərdə tutulub. Ardıcıl olaraq təklif olunan seçimləri istifadə edərək,
                        əməliyyatları icra etmək olar.
                    </p>
                    <img src="/images/dashboard/support/instruction.gif" alt="İstifadə qaydası" />
                </article>
            </div>
        </div>
    );
};
